var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, reaction } from "mobx";
import { IAS_PATH, IAS_UPDATE_PATH } from "../UI/RoutingUIManager";
import { StudyVersionStatus } from "healthex-common/study.dtos";
export class FeatureManager {
    get features() {
        return this._features;
    }
    constructor(featureService, routingUIManager, studyService, authManager) {
        this.featureService = featureService;
        this.routingUIManager = routingUIManager;
        this.studyService = studyService;
        this.authManager = authManager;
        this._features = [];
        this.currentStudyId = undefined;
        this.currentUserId = undefined;
        reaction(() => this.routingUIManager.currentRoute, () => {
            var _a, _b, _c, _d;
            const userId = this.authManager.id;
            let studyId;
            if (((_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.studyId) === IAS_PATH ||
                ((_b = this.routingUIManager.currentRouteParams) === null || _b === void 0 ? void 0 : _b.studyId) === IAS_UPDATE_PATH) {
                studyId = null;
            }
            else {
                studyId = (_d = (_c = this.routingUIManager.currentRouteParams) === null || _c === void 0 ? void 0 : _c.studyId) !== null && _d !== void 0 ? _d : null;
            }
            if (userId !== this.currentUserId || studyId !== this.currentStudyId) {
                this.currentUserId = userId;
                this.currentStudyId = studyId;
                void this.refreshFeatures();
            }
        }, { fireImmediately: true, name: "FeatureManager_currentRoute" });
    }
    isFeatureEnabled(featureFlag) {
        return this.features.some((f) => f.feature === featureFlag && f.enabled);
    }
    getFeatureConfiguration(featureFlag) {
        var _a, _b;
        return (_b = (_a = this.features.find((f) => f.feature === featureFlag)) === null || _a === void 0 ? void 0 : _a.configuration) !== null && _b !== void 0 ? _b : null;
    }
    decodeFeatureConfiguration(featureFlag) {
        var _a, _b;
        return (_b = (_a = this.features.find((f) => f.feature === featureFlag)) === null || _a === void 0 ? void 0 : _a.decodeConfiguration()) !== null && _b !== void 0 ? _b : null;
    }
    async refreshFeatures() {
        try {
            let organizationId;
            if (this.currentStudyId) {
                organizationId = await this.studyService
                    .getStudyPublicInfoById(this.currentStudyId, StudyVersionStatus.ACTIVE)
                    .then((study) => study === null || study === void 0 ? void 0 : study.addedByOrganization.id);
            }
            if (this.currentUserId) {
                const features = await this.featureService.getFeaturesForUser(this.currentUserId, organizationId !== null && organizationId !== void 0 ? organizationId : null);
                this._features = features;
            }
            else if (organizationId) {
                const features = await this.featureService.getFeaturesForOrganization(organizationId);
                this._features = features;
            }
            else {
                const features = await this.featureService.getGlobalFeatures();
                this._features = features;
            }
        }
        catch (error) {
            this._features = [];
        }
    }
}
__decorate([
    observable
], FeatureManager.prototype, "_features", void 0);
